import { CreatePaymentMethodOutcome } from "@models/paymentMethod";

// What the customer is told after a card save went through (audit MB-07, rulings
// 2026-10-20). Only for a 200: every one of these is a success, so none sends the
// customer to support, and none names an amount (ruled out).
//
// A missing, None or unknown outcome claims nothing about the membership: the
// card is stored, and that is all the response proves.
export const savedCardMessage = (
    outcome: CreatePaymentMethodOutcome | undefined,
): string => {
    switch (outcome) {
        case CreatePaymentMethodOutcome.MembershipActivated:
            return "Your card is saved and your membership is active. You can start ordering.";
        case CreatePaymentMethodOutcome.MembershipRenewed:
            return "Your card is saved and your membership has been renewed. Thanks for staying with us.";
        default:
            return "Your card is saved.";
    }
};

// The wall's copy when its membership check (getMeUser) failed. The save's own
// report still stands, but nobody has confirmed the wall will lift, so it must
// not say ordering is open.
export const unconfirmedSavedCardMessage = (
    outcome: CreatePaymentMethodOutcome | undefined,
): string =>
    outcome === CreatePaymentMethodOutcome.MembershipActivated
        ? "Your card is saved and your membership is active."
        : savedCardMessage(outcome);
